import React, { useState } from 'react';
import { parseISO, format } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';

import api from './../../../services/api';
import './lista_parcelas_carne_styles.css';
import Load from '../../load';
import InstrucoesPagamentoPix from './instrucoes_pagamento_pix';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

export default function ListaParcelasCarne(props) {
  const [showDadosPagamentoFeito, setShowDadosPagamentoFeito] = useState(false);
  const [showQrCodeDialod, setShowQrCodeDialod] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const [pixText, setPixText] = useState();
  const [pixExpirationDate, setPixExpirationDate] = useState();
  const [pixLinkQrCode, setPixLinkQrCode] = useState();
  const [slipPago, setSlipPago] = useState();

  const linkedSlips = () => {
    const paymentSlips = props.paymentSlips ?? [];
    const list = [];
    for (let i = 0; i < paymentSlips.length; i++) {
      const obj = {
        anterior: paymentSlips[i - 1],
        atual: paymentSlips[i],
        proximo: paymentSlips[i + 1],
      };
      list.push(obj);
    }
    return list;
  };

  const transformDate = (data, formatData) => {
    if (!data) {
      return '';
    }
    var dateAt = parseISO(data);
    if (!formatData) {
      formatData = "dd 'de' MMMM ' às ' HH:mm 'hrs' ";
    }
    return format(dateAt, formatData, { locale: pt });
  };

  const transformCurrency = (value) => {
    var formatter = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(value);
  };

  const gerarPix = async (slip) => {
    if (slip.status !== 'AGUARDANDO_PAGAMENTO') {
      return;
    }
    setLoading(true);
    try {
      const response = await api.get(
        `/orders/payment-slips?spliId=${slip.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 204) {
        const paymentSlip = response.data;
        
        if (paymentSlip.status === 'PAGO') {
          setSlipPago(paymentSlip);
          setShowDadosPagamentoFeito(true);
        } else if (paymentSlip.pix_text != null) {
          setShowQrCodeDialod(true);
          setPixText(paymentSlip.pix_text);
          setPixExpirationDate(paymentSlip.pix_expiration_date);
          setPixLinkQrCode(paymentSlip.pix_link_qr_code);
        } else {
          alert('Houve um erro ao identificar a forma de pagamento');
        }
      } else {
        alert('Erro ao gerar o PIX');
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.data && err.response.data.error) {
        alert(err.response.data.error);
      } else if (err.error) {
        alert(err.error);
      } else {
        alert('Houve um erro ao gerar o PIX');
      }
    } finally {
      setLoading(false);
    }
  };

  const closeDadosPagamentoFeito = () => {
    setSlipPago(null);
    setShowDadosPagamentoFeito(false);
    props.reloadPaymentSlips();
  };

  return (
    <div>
      {(linkedSlips() ?? []).length > 0 ? (
        <div>
          <table className='table table-striped' style={{ padding: '0.5em' }}>
            <thead>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th></th>
            </thead>
            <tbody>
              {(linkedSlips() ?? []).map((slip) => {
                return (
                  <tr key={slip.atual.id} style={{ border: '1px solid black' }}>
                    <td style={{ textAlign: 'center' }}>
                      {' '}
                      {('00' + slip.atual.number_slip).slice(-2)}{' '}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {transformDate(slip.atual.due_at, 'dd/MM/yyyy')}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {transformCurrency(slip.atual.amount)}{' '}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {(!slip.anterior || slip.anterior.status === 'PAGO') &&
                      slip.atual.status !== 'CANCELADO' ? (
                        <button
                          className={
                            slip.atual.status === 'PAGO'
                              ? 'button-paid'
                              : 'button'
                          }
                          // disabled={slip.atual.status !== 'AGUARDANDO_PAGAMENTO'}
                          onClick={() => {
                            if (slip.atual.status === 'AGUARDANDO_PAGAMENTO') {
                              gerarPix(slip.atual);
                            } else if (slip.atual.status === 'PAGO') {
                              setSlipPago(slip.atual);
                              setShowDadosPagamentoFeito(true);
                            }
                          }}
                        >
                          {slip.atual.status === 'AGUARDANDO_PAGAMENTO'
                            ? slip.atual.pix_text
                              ? 'Ver PIX'
                              : 'Gerar PIX'
                            : null}
                          {slip.atual.status === 'PAGO' ? 'PAGO' : null}
                        </button>
                      ) : slip.atual.status === 'CANCELADO' ? (
                        'CANCELADO'
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <InstrucoesPagamentoPix
            open={showQrCodeDialod}
            onClose={() => {
              setShowQrCodeDialod(false);
              props.reloadPaymentSlips();
            }}
            pixExpirationDate={pixExpirationDate}
            pixLinkQrCode={pixLinkQrCode}
            pixText={pixText}
          />
          <Load loading={loading} />
          <Dialog
            open={showDadosPagamentoFeito}
            keepMounted={false}
            onClose={() => closeDadosPagamentoFeito()}
            disableEscapeKeyDown
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
          >
            <DialogContent>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <h3>Dados do Pagamento</h3>

                <div
                  className='text-info'
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    width: '400px',
                    alignItems: 'start',
                    flexDirection: 'column',
                  }}
                >
                  <span>{slipPago?.pix_end_to_end_id}</span>
                  <span>{slipPago?.pix_holder_name}</span>
                  <span>{slipPago?.pix_holder_tax_id}</span>
                  <span>
                    Valor pago:{' '}
                    {slipPago?.amount_paid
                      ? transformCurrency(slipPago?.amount_paid)
                      : null}
                  </span>
                  <span>
                    Pago em:{' '}
                    {slipPago?.paid_at
                      ? transformDate(slipPago?.paid_at)
                      : null}
                  </span>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <button
                className='button'
                onClick={() => closeDadosPagamentoFeito()}
              >
                Fechar
              </button>
            </DialogActions>
          </Dialog>
        </div>
      ) : null}
    </div>
  );
}
